export default __webpack_public_path__ + "static/media/me.aec87eed.jpg";